import React, { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'サービスの費用感はどのくらいでしょうか？',
      answer: 'プロジェクトの規模や内容により異なりますが、月額10万円〜のライトプランから、大規模プロジェクトまで柔軟に対応いたします。まずはお気軽にご相談ください。詳細な見積もりを無料でご提供いたします。'
    },
    {
      question: '最短でいつから着手可能ですか？',
      answer: 'ご契約後、最短1週間で着手可能です。緊急性の高い案件については、お問い合わせから48時間以内の対応も可能な場合があります。まずは現在の状況とご希望のスケジュールをお聞かせください。'
    },
    {
      question: '共同事業（JV）のスキームについて教えてください',
      answer: '地域の特性や事業内容に応じて、最適なパートナーシップ形態をご提案いたします。リスク分担から収益配分まで、双方にメリットのある持続可能なスキームを構築します。過去の成功事例もご紹介可能です。'
    },
    {
      question: 'メディア取材の流れを教えてください',
      answer: 'お問い合わせ後、3分程度のヒアリングで概要を把握し、24時間以内に詳細な提案書をお送りします。資料提供、写真手配、ロケーション調整まで一括でサポートいたします。メディアの特性に応じた最適なコンテンツをご提供します。'
    },
    {
      question: '採用の選考プロセスはどのようになっていますか？',
      answer: '書類選考→一次面接→最終面接の3段階で実施しています。地域への貢献意欲と成長意欲を重視し、経験よりもポテンシャルを評価します。各ステップでフィードバックを行い、透明性の高い選考を心がけています。'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const handleContactClick = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-32 bg-[#F2F5F9] mb-32" id="faq">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-20">
            <p className="text-sm font-medium uppercase tracking-wider mb-6"
               style={{ color: 'rgb(11, 61, 145)' }}>
              FAQ
            </p>
            <h2 className="text-3xl lg:text-4xl font-bold text-[#111827] mb-16 leading-relaxed">
              よくあるご質問
            </h2>
            <p className="text-xl text-gray-600 leading-loose">
              お客様からよくいただくご質問にお答えします
            </p>
          </div>

          <div className="space-y-6 mb-20">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-6 py-5 text-left flex items-center justify-between cursor-pointer hover:bg-gray-50 transition-colors duration-200"
                >
                  <h3 className="text-lg font-medium text-[#111827] pr-4 leading-relaxed">
                    {faq.question}
                  </h3>
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-[#0B3D91] text-xl transition-all duration-200`}></i>
                  </div>
                </button>
                
                <div className={`transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                } overflow-hidden`}>
                  <div className="px-6 pb-6">
                    <div className="border-t border-gray-100 pt-5">
                      <p className="text-gray-600 leading-loose">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* 詳細ページへのリンク */}
          <div className="text-center">
            <div className="bg-white rounded-2xl p-10 shadow-sm border border-gray-100">
              <h3 className="text-xl font-bold text-[#111827] mb-6 leading-relaxed">
                その他のご質問はございませんか？
              </h3>
              <p className="text-gray-600 mb-8 leading-loose">
                こちらに記載のない内容でも、お気軽にお問い合わせください。<br />
                専門スタッフが丁寧にお答えいたします。
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button 
                  onClick={handleContactClick}
                  className="border border-[#0B3D91] text-[#0B3D91] px-6 py-3 rounded-lg font-medium cursor-pointer hover:text-white transition-all duration-200 whitespace-nowrap"
                  style={{ 
                    '--hover-bg': 'rgb(64 191 180)'
                  } as React.CSSProperties}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = 'rgb(64 191 180)';
                    e.currentTarget.style.borderColor = 'rgb(64 191 180)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                    e.currentTarget.style.borderColor = '#0B3D91';
                  }}
                >
                  直接お問い合わせ
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
